


















































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import OneService from "@/components/medicalEdit/specification/part/OneService.vue";
import ServicePublicMoney from "@/components/medicalEdit/specification/part/ServicePublicMoney.vue";
@Component({
  components: { OneService, ServicePublicMoney }
})
export default class BasicMedical3 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Emit("changealltotal")
  public changealltotal() {
    return;
  }
  @Emit("changepublicmoney1")
  public changepublicmoney1() {
    return;
  }
  @Emit("changepublicmoney2")
  public changepublicmoney2() {
    return;
  }
}
